import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { FC } from 'react';
import { MadeInStoreComponent } from '../../../../app/services/api/generated';
import ComponentRow from './ComponentRow';
import { useTranslation } from 'react-i18next';
import { TableHeader } from '../../../../components/forms/TableHeader';
import { Section } from '../../../../components/ui/Section';
import { Pill } from '../../../../components/shared/Pill';

type Props = {
  ingredients: MadeInStoreComponent[];
}

const MadeInStoreIngredients: FC<Props> = ({ ingredients }) => {
  const { t } = useTranslation('recipe');

  return (
    <Box sx={{ p: 5 }}>
      {ingredients?.length === 0 ? (
        <Typography variant='textMD'>
          {t('noComponents')}
        </Typography>
      ) : (
        <Section>
          <TableHeader>
            {t('madeInStoreComponents')}
            {ingredients?.length > 0 && <Pill text={`${ingredients?.length} ${t('madeInStoreComponents')}`}></Pill>}
          </TableHeader>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('item')}</TableCell>
                <TableCell>{t('description')}</TableCell>
                <TableCell>{t('uom')}</TableCell>
                <TableCell>{t('recipeQuantity')}</TableCell>
                <TableCell>{t('stockOnHand')}</TableCell>
                <TableCell>{t('totalYield')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ingredients.map((item) => (
                <ComponentRow
                  key={item.componentId}
                  item={item} />
              ))}
            </TableBody>
          </Table>
        </Section>
      )
      }
    </Box>
  );
};

export default MadeInStoreIngredients;